import React from "react";
import PropTypes from "prop-types";
import { useTheme } from "styled-components";

import { StepsContainer } from "./Steps.styles";

const Steps = ({ step, total, text, handleClick }) => {
  const theme = useTheme();

  return (
    <StepsContainer>
      {text ? (
        <div className="logo-step-wrapper btn" onClick={handleClick}>
          <span>{text}</span>
        </div>
      ) : (
        <div className="logo-step-wrapper">
          <div
            className="progress-bar"
            style={{
              background: `radial-gradient(closest-side,${
                theme.global.bg.primary
              } 80%,transparent 80% 100%), 
                conic-gradient(${theme.toast.bg.info} ${
                (step / total) * 100
              }%, ${theme.button.bg.disabled} 0)`,
            }}
          >
            <progress value="75" min="0" max="100"></progress>
            <span>
              {step}/{total}
            </span>
          </div>
        </div>
      )}
    </StepsContainer>
  );
};

Steps.propTypes = {
  step: PropTypes.number,
  total: PropTypes.number,
  text: PropTypes.string,
  handleClick: PropTypes.func,
};

export default Steps;
